import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const LoyaltyPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.loyalties,
      component: React.lazy(() => import('./pages/LoyaltiesPage')),
    },
  ],
};

export default LoyaltyPageConfig;
